import { Injectable } from '@angular/core';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';
import { COFINSTaxTable } from '@asm/features/sync/models/pricing-tables.model';

@Injectable({ providedIn: 'root' })
export class COFINSRepository extends RepositoryBase<COFINSTaxTable> {
  protected readonly KEY_PATH = 'cofins';
}
